import styled from 'styled-components';
import media from '../../../../styles/media.style';

import { BLACK, WHITE } from '../../../../styles/variables.style';

export const Container = styled.div`
  :not(:last-child) {
    margin-bottom: 10px;
  }
`;

export const ItemList = styled.li`
  position: relative;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.6);
  box-shadow: 0px 2px 9px 1px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  padding: 20px;
  ${media.tabletP`
    padding: 22px;
    width: 728px;
    flex-direction: row;
  `};
`;

export const ImageCover = styled.div`
  justify-content: center;
  align-items: center;
  margin-right: 20px;
  ${media.tabletP`
    margin-right: 22px;
  `};
`;

export const SectionColumnContainer = styled.div`
  margin-top: ${({ hasPromotionText }) => (hasPromotionText ? '0px' : '22px')}
  display: flex;
  flex-direction: column;
  opacity: 1;
  flex: 1;
`;

export const SectionRowContainer = styled.div`
  margin-top: 25px;
  display: flex;
  flex-direction: row;
  opacity: 1;
  flex: 1;
`;

export const SectionTextTitle = styled.h2`
  font-size: 16px;
  letter-spacing: 1px;
  color: ${BLACK};
  margin-top: 10px;
  ${media.tabletP`
    font-size: 22px;
    margin-top: 0;
    margin-bottom: 14px;
    width: calc(100% - 100px);
  `};
`;

export const SectionTextTitleName = styled.div`
  font-size: 11px;
  letter-spacing: 1px;
  color: #888888;
  ${media.tabletP`
    font-size: 12px;
    margin-bottom: 27px;
  `};
`;

export const SectionTextTitleDesc = styled.ul`
  margin: 19px 0 0 12px;
  li {
    font-size: 12px;
    list-style-type: disc;
    color: ${BLACK};
    position: relative;
  }
  li:not(:last-child) {
    margin-bottom: 5px;
  }
  ${media.tabletP`
    font-size: 15px;
    margin: 0 0 0 12px;
    li {
      font-size: 14px;
    }
    span {
      display: block;
      transform: translateY(2px);
    }
  `};
`;

export const LabelIcon = styled.div`
  position: absolute;
  background-color: ${({ color }) => color || '#dcc787'};
  font-size: 10px;
  border-radius: 14px;
  color: ${WHITE};
  right: 10px;
  top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${({ isHairAndScalp }) => (isHairAndScalp ? '3px 11px' : '3px 13px')};

  ${media.tabletP`
    font-size: 14px;
    width: 98px;
    right: 20px;
    top: 22px;
    ${({ isHairAndScalp }) =>
      isHairAndScalp &&
      `
      font-size: 12px;
      padding: 5px 13px;
      line-height: 13px;
      border-radius: 20px;
    `};
  `};
`;
export const PromotionLabel = styled.div`
  color: #d70303;
  font-size: 11px;
  ${media.tabletP`
    font-size: 12px;
    margin-bottom: 10px;
  `};
`;
export const LabelText = styled.div`
  color: ${({ color }) => color};
  br {
    display: none;
  }
  ${media.tabletP`
    br {
      display: block;
    }
  `};
`;



// WEBPACK FOOTER //
// ./src/pages/SalonConsultationPage/SublimicHomeCareList/SublimicHomeCareListSection/SublimicHomeCareListSection.style.js